import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MenuItem, MenuItemRoute } from '@enums/menu-item.enum';
import { Subscription } from 'rxjs';
import { TonnageGridComponent } from '../../components/tonnage-grid/tonnage-grid.component';
import { TollGridComponent } from '../../components/toll-grid/toll-grid.component';
import * as _moment from 'moment';
import { UiService } from 'app/core/services/ui.service';
const moment = _moment;

@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.scss']
})
export class StatementsComponent implements OnInit, OnDestroy {

  @ViewChild("tabGroup", { static: true }) tabGroup: MatTabGroup;
  @ViewChild("tonnageGrid", { static: true }) tonnageGrid: TonnageGridComponent;
  @ViewChild("tollGrid", { static: true }) tollGrid: TollGridComponent;

  private subscription = new Subscription();
  private notRefresh = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public uiService: UiService
  ) {

  }

  ngOnInit() {
    if (this.route.snapshot.queryParams.selectedTab != null) {
      this.tabGroup.selectedIndex = parseInt(this.route.snapshot.queryParams.selectedTab);
    }
    else {
      const queryParams = {
        selectedTab: 0,
        start: moment().add(-1, 'months').format('DD/MM/YYYY'),
        end: moment().add(1, 'months').format('DD/MM/YYYY')
      };
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams: queryParams
        }
      ).toString()
      this.route.snapshot.queryParams = queryParams;
      this.location.go(url);
      this.filterGrid();
    }

    this.subscription.add(this.tabGroup.selectedIndexChange.subscribe(value => {
      if (!this.notRefresh) {
        const queryParams = {
          selectedTab: value,
        };
        const url = this.router.createUrlTree(
          [],
          {
            relativeTo: this.route,
            queryParams: queryParams
          }
        ).toString()
        this.route.snapshot.queryParams = queryParams;
        this.location.go(url);
        this.filterGrid();
      }
      this.notRefresh = false;
    }));

    this.subscription.add(this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd && event.url.startsWith(MenuItemRoute.get(MenuItem.statements) || "")) {
        this.notRefresh = true;
        this.tabGroup.selectedIndex = parseInt(this.route.snapshot.queryParams.selectedTab);
        setTimeout(() => {
          this.filterGrid();
        });
        // this.filterGrid();
      }
    }));
  }

  private filterGrid() {
    if (this.tabGroup.selectedIndex == 0) {
      this.tonnageGrid.getUrlParam();
      this.tonnageGrid.onFilter();
    }
    if (this.tabGroup.selectedIndex == 1) {
      this.tollGrid.getUrlParam();
      this.tollGrid.onFilter();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
